import {useEffect, useRef} from "react";
import styles from "../styles/SessionTimer.module.scss";
import timerIcon from "../../../assets/images/common/simple_timer_icon.png";
import {useSessionTimer} from "../hooks/useSessionTimer";

type SessionTimerProps = {
  onExpire: () => void;
};

const SessionTimer = ({onExpire}: SessionTimerProps) => {
  const {sessionRemainingSeconds} = useSessionTimer();
  const alreadyCalledRef = useRef(false);

  useEffect(() => {
    if (sessionRemainingSeconds === 0 && !alreadyCalledRef.current) {
      onExpire();
      alreadyCalledRef.current = true;
    }
  }, [sessionRemainingSeconds, onExpire]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${String(remainingSeconds).padStart(2, "0")}`;
  };

  if (sessionRemainingSeconds === null) return <></>;

  return (
    <div className={styles.sessionTimer}>
      <img src={timerIcon} className={styles.sessionTimerIcon} alt="" />
      <p className={styles.sessionTimerText}>
        {formatTime(sessionRemainingSeconds)}
      </p>
    </div>
  );
};

export default SessionTimer;
